/* MSAL (Entra ID / Azure AD) configuration for the Project Everest SPA.

   Identity comes from BJ Entra ID. The ID token MSAL acquires is forwarded to the
   governed backend as `Authorization: Bearer <jwt>`; the backend (everest/identity/entra.py)
   validates it against THIS SAME app registration — `aud == clientId`,
   `iss == https://login.microsoftonline.com/<tenant>/v2.0` — and maps the app-role claim
   onto the backend UserRole. That is why we forward the ID token (not an access token):
   its `aud` is always this app's clientId and it carries the `roles` claim, which is exactly
   what the backend checks — no custom API scope or admin consent required.

   Values are env-overridable (CRA inlines REACT_APP_* at build time) with prod fallbacks,
   matching the REACT_APP_BACKEND_URL pattern in App.jsx, so the build works even before the
   pipeline variables are set. */
const CLIENT_ID = process.env.REACT_APP_AAD_CLIENT_ID || "9dcfbf65-e65e-417f-84ee-c54e4cfdc7e7";
const TENANT_ID = process.env.REACT_APP_AAD_TENANT_ID || "30961325-9c3d-47c6-897d-360b4e954d9e";

// Origin is the SPA redirect URI — must be registered under the app registration's
// "Single-page application" platform (e.g. https://nice-plant-0e7cbf510.7.azurestaticapps.net
// for prod and http://localhost:3000 for local dev).
const ORIGIN = typeof window !== "undefined" ? window.location.origin : "/";

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: ORIGIN,
    postLogoutRedirectUri: ORIGIN,
    // false: process the redirect response in place rather than navigating back to the
    // original request URL. Correct for a single-origin SPA with no client-side router —
    // avoids an extra post-redirect navigation (and re-run of init) on deep links.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // sessionStorage keeps the token to the tab/session (not persisted to disk) — a
    // reasonable default for an internal governed tool. Switch to localStorage if you
    // want sign-in to survive a full browser restart.
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// OIDC scopes only. The backend accepts the resulting ID token, so no custom API scope or
// consent is needed. (To switch the backend to validate an access token later, add the API
// scope here, e.g. `api://<clientId>/user_impersonation`, and forward res.accessToken.)
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
